import register from '../util/init';
import InfScr from '../util/infscr';

function searchInit (container) {
  const allowCache = window.DEBUG ? false : true; // reverses true=false here
  const infscr = InfScr('.paginate', {
    contentSelector: '.page',
    nextSelector: '.next-page',
    autoOffset: 1500,
    allowCache: allowCache,
    beforeLoad: function () {
      // nothing here...
    },
    onLoad: function (newContent, container) {
      // possible add lazyload images?
    }
  });

  return {
    resize: (...args) => {
      infscr.resize.apply(infscr, args);
    },
    scroll: (...args) => {
      infscr.scroll.apply(infscr, args);
    }
  };
}
register('search-full', searchInit);



// WEBPACK FOOTER //
// ./assets/j/src/search.js